import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';

export default function Leads() {
  const [leads, setLeads]   = useState([]);
  const [total, setTotal]   = useState(0);
  const [page, setPage]     = useState(1);
  const [status, setStatus] = useState('');
  const [selected, setSelected] = useState(null);

  const load = useCallback(() => {
    const params = { page, limit: 20, ...(status && { status }) };
    axios.get('/api/leads', { params }).then(r => { setLeads(r.data.leads || r.data); setTotal(r.data.total || 0); });
  }, [page, status]);

  useEffect(() => { load(); }, [load]);

  const updateStatus = async (id, s) => {
    try { await axios.patch(`/api/leads/${id}`, { status: s }); toast.success('Updated'); load(); }
    catch { toast.error('Failed'); }
  };

  const totalPages = Math.ceil(total / 20);

  return (
    <div>
      <div className="page-header">
        <div><h1>Demo Leads</h1><p>{total} requests received</p></div>
      </div>

      <div style={{ display:'grid', gridTemplateColumns: selected ? '1fr 380px' : '1fr', gap:20 }}>
        <div className="card">
          <div className="toolbar">
            <select className="form-control" value={status} onChange={e => { setStatus(e.target.value); setPage(1); }} style={{ maxWidth:160 }}>
              <option value="">All</option>
              {['new','contacted','demo_scheduled','converted','rejected'].map(s => <option key={s} value={s}>{s}</option>)}
            </select>
          </div>
          <div className="table-wrap">
            <table>
              <thead><tr><th>Name</th><th>Email</th><th>Company</th><th>Status</th><th>Date</th><th>Actions</th></tr></thead>
              <tbody>
                {leads.map(l => (
                  <tr key={l.id} style={{ cursor:'pointer' }} onClick={() => setSelected(l)}>
                    <td><strong>{l.name}</strong></td>
                    <td>{l.email}</td>
                    <td>{l.company || '—'}</td>
                    <td>
                      <select className="form-control" value={l.status || 'new'} style={{ width:140 }}
                        onClick={e => e.stopPropagation()}
                        onChange={e => updateStatus(l.id, e.target.value)}>
                        {['new','contacted','demo_scheduled','converted','rejected'].map(s => <option key={s} value={s}>{s}</option>)}
                      </select>
                    </td>
                    <td>{new Date(l.created_at).toLocaleDateString()}</td>
                    <td><button className="btn btn--ghost btn--sm" onClick={e => { e.stopPropagation(); setSelected(l); }}>View</button></td>
                  </tr>
                ))}
                {leads.length === 0 && <tr><td colSpan={6}><div className="empty-state"><div className="icon">📋</div>No leads yet</div></td></tr>}
              </tbody>
            </table>
          </div>
          {totalPages > 1 && (
            <div className="pagination">
              <button onClick={() => setPage(p => p - 1)} disabled={page === 1}>← Prev</button>
              <span className="current">Page {page} of {totalPages}</span>
              <button onClick={() => setPage(p => p + 1)} disabled={page === totalPages}>Next →</button>
            </div>
          )}
        </div>

        {selected && (
          <div className="card" style={{ alignSelf:'start', position:'sticky', top:20 }}>
            <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:20 }}>
              <h3 style={{ fontSize:16, fontWeight:700 }}>Lead Details</h3>
              <button className="btn btn--ghost btn--sm" onClick={() => setSelected(null)}>✕</button>
            </div>
            {[['Name', selected.name],['Email', selected.email],['Company', selected.company || '—'],['Phone', selected.phone || '—'],['Date', new Date(selected.created_at).toLocaleString()]].map(([k,v]) => (
              <div key={k} style={{ marginBottom:12 }}>
                <div style={{ fontSize:11, fontWeight:700, color:'var(--slate)', textTransform:'uppercase', marginBottom:3 }}>{k}</div>
                <div style={{ fontSize:14, color:'var(--dark)' }}>{v}</div>
              </div>
            ))}
            {selected.message && (
              <div>
                <div style={{ fontSize:11, fontWeight:700, color:'var(--slate)', textTransform:'uppercase', marginBottom:3 }}>Message</div>
                <div style={{ fontSize:14, color:'var(--gray)', lineHeight:1.6, background:'var(--surface)', borderRadius:8, padding:'12px' }}>{selected.message}</div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
